import {
  LucideProps,
  LucideIcon,
  Eye,
  EyeOff,
  ChevronsUpDown,
  Check,
  Calendar,
  PlusCircle,
  Plus,
  User,
  Download,
  LayoutDashboard,
  MessageCircle,
  Settings,
  Users,
  Send,
  Loader2,
  X,
  Trash,
  Settings2,
  RotateCw,
  MoreVertical,
  Key,
  PenSquare,
  ToggleLeft,
  ToggleRight,
  Ban,
  PlayCircle,
  PhoneIncoming,
  PhoneOutgoing,
  RotateCcw,
  ScrollText,
  Search,
  SunMedium,
  Cloudy,
  Sparkles,
  Minus,
  Building,
  Folder,
  FileText,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ArrowUpDown,
  MinusCircle,
  Mic,
  ArrowUp,
  ArrowDown,
  ArrowRight,
  UserCheck,
  MessagesSquare,
  Library,
  EarOff,
  File,
  CircleX,
  ArrowLeft,
  ChevronUp,
  Redo,
  Undo,
  BookA,
  Replace,
  ReplaceAll,
  Link,
  Mail,
  Copy
} from 'lucide-react';

export type IconType = LucideIcon;

export const Icons = {
  link: Link,
  eye: Eye,
  eyeoff: EyeOff,
  chevronsUpDown: ChevronsUpDown,
  check: Check,
  calendar: Calendar,
  plusCircle: PlusCircle,
  add: Plus,
  user: User,
  download: Download,
  dashboard: LayoutDashboard,
  users: Users,
  notification: MessageCircle,
  settings: Settings,
  send: Send,
  spinner: Loader2,
  close: X,
  trash: Trash,
  settings2: Settings2,
  refresh: RotateCw,
  moreVertical: MoreVertical,
  key: Key,
  update: PenSquare,
  toggleRight: ToggleRight,
  toggleLeft: ToggleLeft,
  ban: Ban,
  play: PlayCircle,
  phoneIncoming: PhoneIncoming,
  phone: PhoneOutgoing,
  rollback: RotateCcw,
  log: ScrollText,
  search: Search,
  sun: SunMedium,
  cloud: Cloudy,
  sparcles: Sparkles,
  minus: Minus,
  building: Building,
  folder: Folder,
  post: FileText,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  arrowUpDown: ArrowUpDown,
  addCircle: PlusCircle,
  removeCircle: MinusCircle,
  arrowUp: ArrowUp,
  arrowDown: ArrowDown,
  mic: Mic,
  arrowRight: ArrowRight,
  userCheck: UserCheck,
  support: MessagesSquare,
  library: Library,
  earOff: EarOff,
  file: File,
  circleX: CircleX,
  arrowLeft: ArrowLeft,
  redo: Redo,
  undo: Undo,
  bookA: BookA,
  replace: Replace,
  ReplaceAll: ReplaceAll,
  mail: Mail,
  copy: Copy,
  logo: ({ ...props }: LucideProps) => (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="github"
      role="img"
      viewBox="0 0 496 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3 .7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3 .3 2.9 2.3 3.9 1.6 1 3.6 .7 4.3-.7 .7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3 .7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3 .7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
      ></path>
    </svg>
  ),
  naver: ({ ...props }: LucideProps) => (
    <svg width="16" height="16" viewBox="0 0 48 48" role="img" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#00C63B"
          d="M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24z"
        ></path>
        <path
          fill="#FFF"
          d="M21 25.231V34h-7V15h7l6 8.769V15h7v19h-7l-6-8.769z"
        ></path>
      </g>
    </svg>
  ),
  kakao: ({ ...props }: LucideProps) => (
    <svg width="16" height="16" viewBox="0 0 48 48" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFEB00"
          d="M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24z"
        ></path>
        <path
          fill="#3C2929"
          d="M24 11.277c8.284 0 15 5.306 15 11.85 0 6.545-6.716 11.85-15 11.85-.92 0-1.822-.066-2.697-.191l-6.081 4.105a.43.43 0 0 1-.674-.476l1.414-5.282C11.777 31.031 9 27.335 9 23.127c0-6.544 6.716-11.85 15-11.85zm6.22 8.407c-.416 0-.718.297-.718.707v5.939c0 .41.289.686.718.686.41 0 .718-.295.718-.686v-1.932l.515-.526 1.885 2.57c.277.374.426.54.691.568.037.003.075.005.112.005.154 0 .66-.04.716-.563.038-.293-.137-.52-.348-.796l-2.043-2.675 1.727-1.743.176-.196c.234-.26.353-.39.353-.587.009-.422-.34-.652-.687-.661-.274 0-.457.15-.57.262l-2.528 2.634v-2.3c0-.422-.288-.706-.717-.706zm-9.364 0c-.56 0-.918.432-1.067.837l-2.083 5.517a.84.84 0 0 0-.065.315c0 .372.31.663.706.663.359 0 .578-.162.69-.51l.321-.97h2.999l.313.982c.111.335.34.498.7.498.367 0 .655-.273.655-.62 0-.056-.017-.196-.081-.369l-2.019-5.508c-.187-.53-.577-.835-1.069-.835zm-2.92.064h-4.452c-.417 0-.642.337-.642.654 0 .3.168.652.642.652h1.51v5.21c0 .464.274.752.716.752.443 0 .718-.288.718-.751v-5.21h1.508c.474 0 .643-.352.643-.653 0-.317-.225-.654-.643-.654zm7.554-.064c-.442 0-.717.287-.717.75v5.707c0 .497.28.794.75.794h2.674c.434 0 .677-.321.686-.627a.642.642 0 0 0-.17-.479c-.122-.13-.3-.2-.516-.2h-1.99v-5.195c0-.463-.274-.75-.717-.75zm-4.628 1.306l.008.01 1.083 3.265h-2.192L20.842 21a.015.015 0 0 1 .028 0z"
        ></path>
      </g>
    </svg>
  ),
  google: ({ ...props }: LucideProps) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
      <g clipPath="url(#clip0)">
        <path
          d="M23.9872 12.2242C23.9872 11.2409 23.9055 10.5234 23.7288 9.7793H12.2389V14.2173H18.9832C18.8473 15.3202 18.113 16.9811 16.4813 18.0972L16.4584 18.2458L20.0913 20.996L20.343 21.0206C22.6546 18.9344 23.9872 15.8649 23.9872 12.2242Z"
          fill="#4285F4"
        />
        <path
          d="M12.2391 23.9178C15.5433 23.9178 18.3171 22.8548 20.3433 21.0211L16.4815 18.0978C15.4481 18.8021 14.0611 19.2937 12.2391 19.2937C9.00291 19.2937 6.25623 17.2076 5.27711 14.3242L5.13359 14.3361L1.35604 17.193L1.30664 17.3272C3.31906 21.2337 7.45273 23.9178 12.2391 23.9178Z"
          fill="#34A853"
        />
        <path
          d="M5.27739 14.3248C5.01904 13.5807 4.86952 12.7834 4.86952 11.9596C4.86952 11.1357 5.01904 10.3385 5.26379 9.5944L5.25695 9.43592L1.43206 6.5332L1.30692 6.59137C0.477507 8.21247 0.00158691 10.0329 0.00158691 11.9596C0.00158691 13.8863 0.477507 15.7066 1.30692 17.3277L5.27739 14.3248Z"
          fill="#FBBC05"
        />
        <path
          d="M12.2391 4.62403C14.5371 4.62403 16.0872 5.59401 16.971 6.40461L20.4248 3.10928C18.3036 1.1826 15.5433 0 12.2391 0C7.45273 0 3.31906 2.68406 1.30664 6.59056L5.26351 9.59359C6.25623 6.7102 9.00291 4.62403 12.2391 4.62403Z"
          fill="#EB4335"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  chunk: ({ ...props }: LucideProps) => (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.6668 4.44444H29.2223L22.1112 27.5556H19.5557L26.6668 4.44444Z"
        fill="#0869DC"
      />
      <path
        d="M16.0115 8V13.2787H18V15.0842H16.0115V22H13.6836V8H16.0115ZM12.0023 9.40765C12.0023 13.6765 10.3533 17.318 5.30947 19.659L4 17.976C7.403 16.3617 9.22979 14.2656 9.64203 11.2131H4.88915V9.40765H12.0023Z"
        fill="#5C5C5C"
      />
    </svg>
  )
};
